<script>
  import { parse } from "date-fns";
  import { _ as t } from "svelte-i18n";

  export let value;
  export let label;
  export let type = "text";
  export let error = null;
  export let long = false;

  let helper = null;

  $: n = value ? value.length : 1;

  $: {
    if (type === "date" && value.length > 3) {
      let v;
      try {
        v = parse(value, "d/MM/yyyy", new Date()).toString();
      } catch (e) {
        helper = $t("conversation.example");
      }
      if (v === "Invalid Date") {
        helper = $t("conversation.example");
      } else {
        helper = null;
      }
    }
  }
</script>

<div class="group">
  <input type="text" bind:value class:long required style={`width: ${n}ch`} />
  <label for="">{label}</label>
  {#if error}
    <p class="helper error">{error}</p>
  {/if}
  {#if helper}
    <p class="helper">{helper}</p>
  {/if}
</div>

<style>
  .group {
    position: relative;
    margin-top: 18px;
    margin-bottom: 0;
    display: inline-block;
  }

  @media only screen and (min-width: 600px) {
    .group {
      margin-top: 0;
      margin-bottom: 25px;
    }
  }

  input {
    box-sizing: content-box;
    font-size: 14px;
    padding: 10px 10px 10px 5px;
    display: block;
    min-width: 100px;
    border: none;
    border-bottom: 1px solid #bbb;
  }

  @media only screen and (min-width: 600px) {
    input {
      font-size: 22px;
      padding: 5px 5px 5px 5px;
      min-width: 150px;
    }
  }

  .long {
    min-width: 150px;
  }

  @media only screen and (min-width: 600px) {
    .long {
      min-width: 250px;
    }
  }
  input:focus {
    outline: none;
  }

  /* LABEL */
  label {
    color: #999;
    font-size: 13px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 10px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
  }

  @media only screen and (min-width: 600px) {
    label {
      font-size: 18px;
    }
  }

  /* active state */
  input:focus ~ label,
  input:valid ~ label {
    top: -10px;
    font-size: 12px;
    color: var(--seppia-color);
  }

  @media only screen and (min-width: 600px) {
    input:focus ~ label,
    input:valid ~ label {
      top: -20px;
      font-size: 14px;
      color: var(--seppia-color);
    }
  }

  .helper {
    font-size: 12px;
    color: var(--marine-color);
    position: absolute;
    bottom: -20px;
  }

  .helper.error {
    color: tomato;
  }
</style>
